import { createFileRoute } from '@tanstack/react-router';
import { AutomationsSettingsPage } from '@/features/automations/automations-page';

const SCOPES = ['workspace', 'space', 'folder', 'list'] as const;
type ScopeType = (typeof SCOPES)[number];

export const Route = createFileRoute('/w/$workspaceId/settings/automations')({
  // `?scopeType=list&scopeId=lst_x` opens the automations of one location.
  validateSearch: (search: Record<string, unknown>): { scopeType?: ScopeType; scopeId?: string } => ({
    ...(SCOPES.includes(search.scopeType as ScopeType) ? { scopeType: search.scopeType as ScopeType } : {}),
    ...(typeof search.scopeId === 'string' ? { scopeId: search.scopeId } : {}),
  }),
  component: AutomationsRoute,
});

function AutomationsRoute() {
  const { scopeType, scopeId } = Route.useSearch();
  return <AutomationsSettingsPage scopeType={scopeType} scopeId={scopeId} />;
}
